(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tutibloom-asset-video"] && !Shopify.designMode) return;
  try {
    /* In-view loop playback. Bundled once even if this snippet renders 4 times.
     Videos with data-tb-mq only attach a source after that query matches. */
  (() => {
    const SELECTOR = 'video.tb-loop-video';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const bound = new WeakSet();

    function matchesMq(video) {
      const mq = video.getAttribute('data-tb-mq');
      return !mq || window.matchMedia(mq).matches;
    }

    function harden(video) {
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.disablePictureInPicture = true;
    }

    function ensureSrc(video) {
      if (video.querySelector('source') || video.getAttribute('src')) return;

      const sourcesAttr = video.getAttribute('data-tb-sources');
      if (sourcesAttr) {
        let sources = [];
        try {
          sources = JSON.parse(sourcesAttr);
        } catch (error) {
          return;
        }
        sources.forEach((item) => {
          if (!item || !item.src) return;
          const source = document.createElement('source');
          source.src = item.src;
          if (item.type) source.type = item.type;
          video.appendChild(source);
        });
        video.load();
        return;
      }

      const url = video.getAttribute('data-tb-src');
      if (!url) return;
      const source = document.createElement('source');
      source.src = url;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
    }

    function tryPlay(video) {
      if (!matchesMq(video) || reducedMotion.matches) {
        video.pause();
        return;
      }
      ensureSrc(video);
      const attempt = video.play();
      if (attempt) {
        attempt.catch(() => {
          const onReady = () => {
            if (matchesMq(video) && !reducedMotion.matches) {
              video.play().catch(() => {});
            }
            video.removeEventListener('canplay', onReady);
          };
          video.addEventListener('canplay', onReady);
        });
      }
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (!(video instanceof HTMLVideoElement)) continue;
          if (entry.isIntersecting) tryPlay(video);
          else video.pause();
        }
      },
      { threshold: 0.35 }
    );

    function bind(video) {
      if (!(video instanceof HTMLVideoElement) || bound.has(video)) return;
      bound.add(video);
      harden(video);
      observer.observe(video);
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll(SELECTOR).forEach(bind);
    }

    function pauseMismatched() {
      document.querySelectorAll(SELECTOR).forEach((video) => {
        if (!matchesMq(video)) video.pause();
      });
    }

    scan(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(SELECTOR)) bind(node);
          else scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    reducedMotion.addEventListener('change', () => {
      if (!reducedMotion.matches) return;
      document.querySelectorAll(SELECTOR).forEach((video) => video.pause());
    });

    window.matchMedia('(min-width: 750px)').addEventListener('change', pauseMismatched);
  })();
  } catch(e) { console.error(e); }
})();

})();
